import { createRouter, createWebHashHistory } from 'vue-router'

export const homePages = [
  { name: '万事胜意', path: '/home1', file: 'home1' },
  { name: '赛博朋克', path: '/home2', file: 'home2' },
  { name: '星辰大海', path: '/home3', file: 'home3' },
  { name: '平安喜乐', path: '/home4', file: 'home4' },
  { name: '梦想成真', path: '/home5', file: 'home5' },
]

const getHomeRoutes = () => {
  return homePages.map((page) => {
    return {
      path: page.path,
      name: page.file,
      component: () => import(`@/pages/home/${page.file}.vue`),
    }
  })
}

const legacyHomeRedirects = homePages.map((page) => ({
  path: `/overt/welcome/${page.file}`,
  redirect: page.path,
}))

const standalonePages = [
  {
    path: '/home1/blogplanet',
    name: 'blogplanet',
    component: () => import('@/pages/home/home1/BlogPlanet.vue'),
  },
  {
    path: '/home1/scholarplanet',
    name: 'scholarplanet',
    component: () => import('@/pages/home/home1/ScholarPlanet.vue'),
  },
  {
    path: '/home1/pixelplanet',
    name: 'pixelplanet',
    component: () => import('@/pages/home/home1/PixelPlanet.vue'),
  },
  {
    path: '/home1/imageplanet',
    name: 'imageplanet',
    component: () => import('@/pages/home/home1/ImagePlanet.vue'),
  },
  {
    path: '/home1/flightguide',
    name: 'flightguide',
    component: () => import('@/pages/home/home1/FlightGuide.vue'),
  },
  {
    path: '/home2/productprototype',
    name: 'productprototype',
    component: () => import('@/pages/home/home2/ProductPrototype.vue'),
  },
  {
    path: '/home2/uidesign',
    name: 'uidesign',
    component: () => import('@/pages/home/home2/UIDesign.vue'),
  },
  {
    path: '/home2/uxinteraction',
    name: 'uxinteraction',
    component: () => import('@/pages/home/home2/UXInteraction.vue'),
  },
  {
    path: '/home2/internetthings',
    name: 'internetthings',
    component: () => import('@/pages/home/home2/InternetThings.vue'),
  },
  {
    path: '/home3/jingzhe',
    name: 'jingzhe',
    component: () => import('@/pages/home/home3/JingZhe.vue'),
  },
  {
    path: '/home3/guyu',
    name: 'guyu',
    component: () => import('@/pages/home/home3/GuYu.vue'),
  },
  {
    path: '/home3/liqiu',
    name: 'liqiu',
    component: () => import('@/pages/home/home3/LiQiu.vue'),
  },
  {
    path: '/home3/fengjiedong',
    name: 'fengjiedong',
    component: () => import('@/pages/home/home3/FengJieDong.vue'),
  },
  {
    path: '/home3/chongsuxing',
    name: 'chongsuxing',
    component: () => import('@/pages/home/home3/ChongSuXing.vue'),
  },
  {
    path: '/home3/yujinbing',
    name: 'yujinbing',
    component: () => import('@/pages/home/home3/YuJinBing.vue'),
  },
  {
    path: '/home4/checklist',
    name: 'checklist',
    component: () => import('@/pages/home/home4/Checklist.vue'),
  },
  {
    path: '/home4/declutter',
    name: 'declutter',
    component: () => import('@/pages/home/home4/Declutter.vue'),
  },
  {
    path: '/home4/memo',
    name: 'memo',
    component: () => import('@/pages/home/home4/Memo.vue'),
  },
  {
    path: '/home5/inspirationboard',
    name: 'inspirationboard',
    component: () => import('@/pages/home/home5/InspirationBoard.vue'),
  },
  {
    path: '/home5/restartlife',
    name: 'restartlife',
    component: () => import('@/pages/home/home5/RestartLife.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { top: 0, left: 0 }
  },
  routes: [
    { path: '/', redirect: '/home1' },
    ...legacyHomeRedirects,
    ...standalonePages,
    {
      path: '/',
      component: () => import('@/layouts/Welcome.vue'),
      children: getHomeRoutes()
    },
    {
      path: '/',
      component: () => import('@/layouts/Blank.vue'),
      children: [
        {
          path: '/:pathMatch(.*)*',
          component: () => import('@/pages/Error.vue'),
        },
      ]
    },
  ]
})

export default router
